module.exports = __webpack_public_path__ + "img/pp400x70.8fc8b42e.png";